module.exports = __webpack_public_path__ + "img/36005-008.6e63f8bb.jpg";